import { render, staticRenderFns } from "./Collateral.vue?vue&type=template&id=75d44594&scoped=true&"
import script from "./Collateral.vue?vue&type=script&lang=js&"
export * from "./Collateral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d44594",
  null
  
)

export default component.exports